/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
import React from "react";
import { classNames } from "@plasmicapp/react-web";

export type Poly5IconProps = React.ComponentProps<"svg"> & {
  title?: string;
};

export function Poly5Icon(props: Poly5IconProps) {
  const { className, style, title, ...restProps } = props;
  return (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      fill={"none"}
      viewBox={"0 0 113 140"}
      height={"1em"}
      className={classNames("plasmic-default__svg", className)}
      style={style}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <path
        stroke={"currentColor"}
        strokeLinejoin={"round"}
        strokeWidth={"2"}
        d={
          "M19.973 1 83.46 16.814 111.189 71.2l-19.702 67.5-64.582-19.286L1 71.2z"
        }
      ></path>
    </svg>
  );
}

export default Poly5Icon;
/* prettier-ignore-end */
